/** Sanity slug for the discovery homepage document (served at `/`, not `/[slug]`). */
export const HOMEPAGE_SLUG = "homepage";

export const PRIVACY_POLICY_SLUGS = [
	"privacy",
	"product-privacy",
	"coppa",
	"coppa-full",
];

/** Beast Academy Modality slug */
export const BEAST_ACADEMY_MODALITY_SLUG = "beast-academy";

/** Beast Academy Online enrollment / subscription page */
export const BEAST_ACADEMY_ENROLL_URL =
	"https://beastacademy.com/online/enroll";

/** Platform application code for auth/gateway. */
export const PLATFORM_APPLICATION_CODE = "one";

/** Maximum character length for course card descriptions before truncation. */
export const COURSE_CARD_DESCRIPTION_MAX_LENGTH = 150;

export const DISCOVERY_HEADER_ID = "discovery-header";

/** LaunchDarkly flag that shows Sign in / account menu in the Discovery header. */
export const ENABLE_DISCOVERY_MILESTONE_2_FLAG = "enable-discovery-milestone-2";
